import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const AppAndBrowser = ({
  height = 24,
  width = 24,
  color = colors.secondaryText,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    color={color}
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.02478 1.76636C1.65341 1.76636 0.541687 2.87808 0.541687 4.24946V10.281C0.541687 11.6523 1.65322 12.7641 3.02465 12.7641H5.20357L5.02976 13.7498H4.59533C4.29731 13.7498 4.05572 13.9914 4.05572 14.2894C4.05572 14.5874 4.29731 14.829 4.59533 14.829H9.34525C9.64327 14.829 9.88486 14.5874 9.88486 14.2894C9.88486 13.9914 9.64327 13.7498 9.34525 13.7498H8.89428L8.72047 12.7641H8.83011C9.12813 12.7641 9.36972 12.5225 9.36972 12.2245C9.36972 11.9264 9.12813 11.6848 8.83011 11.6848H3.02465C2.25044 11.6848 1.62267 11.0581 1.62091 10.2842H8.8302C9.12822 10.2842 9.36981 10.0426 9.36981 9.74461C9.36981 9.44659 9.12822 9.205 8.8302 9.205H1.62091V4.24946C1.62091 3.47412 2.24945 2.84558 3.02478 2.84558H11.04C11.8153 2.84558 12.4439 3.47411 12.4439 4.24945V4.78559C12.4439 5.08361 12.6855 5.3252 12.9835 5.3252C13.2815 5.3252 13.5231 5.08361 13.5231 4.78559V4.24945C13.5231 2.87808 12.4114 1.76636 11.04 1.76636H3.02478ZM6.12563 13.7498L6.29944 12.7641H7.6246L7.79841 13.7498H6.12563Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4464 6.15742C10.6618 6.15742 10.0257 6.79347 10.0257 7.57808V13.4085C10.0257 14.1931 10.6618 14.8292 11.4464 14.8292H14.0377C14.8223 14.8292 15.4584 14.1931 15.4584 13.4085V7.57808C15.4584 6.79347 14.8223 6.15742 14.0377 6.15742H11.4464ZM11.1049 7.57808C11.1049 7.38951 11.2578 7.23664 11.4464 7.23664H14.0377C14.2263 7.23664 14.3791 7.38951 14.3791 7.57808V11.8065H11.1049V7.57808ZM11.1049 13.4085V12.8857H14.3791V13.4085C14.3791 13.5971 14.2263 13.75 14.0377 13.75H11.4464C11.2578 13.75 11.1049 13.5971 11.1049 13.4085Z"
    />
  </SvgIcon>
);
